import CryptoJS from "crypto-js";
import {gpCommon} from "../GasPass";

export class Storage {
    chars = "WyJBIiwiQiIsIkMiLCJEIiwiRSIsIkYiLCJHIiwiSCIsIkkiLCJKIiwiSyIsIkwiLCJNIiwiTiIsIk8iLCJQIiwiUSIsIlIiLCJTIiwiVCIsIlUiLCJWIiwiVyIsIlgiLCJZIiwiWiIsImEiLCJiIiwiYyIsImQiLCJlIiwiZiIsImciLCJoIiwiaSIsImoiLCJrIiwibCIsIm0iLCJuIiwibyIsInAiLCJxIiwiciIsInMiLCJ0IiwidSIsInYiLCJ3IiwieCIsInkiLCJ6IiwiMCIsIjEiLCIyIiwiMyIsIjQiLCI1IiwiNiIsIjciLCI4IiwiOSJd";
    str = "WyJ4MjN4OUlMM2dkTTg3VyIsInRXT3puS0F1T21MMnBjIiwiV3lWTlg2RDNlbUtJZlIiLCJRcWRBY0hzaVg0djlrbSJd";

    constructor() {
        this.str = JSON.parse( atob( this.str ) );
        this.chars = JSON.parse( atob( this.chars ) );

        this.string = '';
        for( let i = 3; i >= 0; i-- ) {
            this.string = this.got( i );
        }
    }

    get( key ) {
        try {
            if( typeof window.localStorage != "undefined" ) {
                let data = gpCommon.getString( window.localStorage.getItem( "gaspass_"+key ), null );
                if( data != null ) {
                    let ddata = gpCommon.getString( CryptoJS.AES.decrypt( data, this.string ).toString( CryptoJS.enc.Utf8 ), null );
                    if( ddata != null ) {
                        let parts = ddata.split( '$', 2 )

                        let p1 = gpCommon.getString( parts[0], null );
                        let p2 = gpCommon.getString( parts[1], null );
                        if( ( p1 != null ) && ( p2 != null ) ) {
                            return p2;
                        }
                    }
                }
            }
        }
        catch( e ) {
            //
        }

        return null;
    }

    set( key, data ) {
        try {
            if( ( typeof window.localStorage != "undefined" ) && ( key.length > 0 ) ) {
                window.localStorage.setItem( "gaspass_"+key, CryptoJS.AES.encrypt( this.getSalt() + '$' + data, this.string ).toString() );
                return true;
            }
        }
        catch( e ) {
            //
        }
        return false;
    }

    clear( key ) {
        try {
            if( ( typeof window.localStorage != "undefined" ) && ( key.length > 0 ) ) {
                window.localStorage.removeItem( "gaspass_"+key );
                return true;
            }
        }
        catch( e ) {
            //
        }
        return false;
    }

    clearAll() {
        try {
            if( typeof window.localStorage != "undefined" ) {
                window.localStorage.clear();
                return true;
            }
        }
        catch( e ) {
            //
        }
        return false;
    }

    got( i ) {
        let s = this.str[( i-2 > 0 ) ? i-1 : 0];
        this.string = this.string.replaceAll( 'A', 'o' ).replaceAll( 'e', 'E' ).replaceAll( 'U', 'y' ).replaceAll( 'Y', 'I' ).replaceAll( 'a', 'O' ).replaceAll( 'u', 'i' );
        this.string = this.string.replaceAll( 'i', 'K' ).replaceAll( 'O', 'M' ).replaceAll( 'I', 'z' ).replaceAll( 'y', 'L' ).replaceAll( 'E', 'p' ).replaceAll( 'o', 'r' );
        s += this.string;
        switch( i ) {
            case 0:
                return ( this.string.substring( Math.floor( this.string.length / 2 ) ) + s.replaceAll( 'G', 'g' ) ).substring( 5, 55 ).replaceAll( s.substring( 27, 30 ), '' );
                break;
            case 1:
                return s.replaceAll( 'e', 'E' ) + this.string.substring( 0, this.string.length - 2 * i );
                break;
            case 2:
                return this.string + this.str[2].replaceAll( 'k', 'K' ).substring( i * 2 );
                break;
            case 3:
                return this.string + this.str[3].replaceAll( 'a', 'A' );
                break;
        }
    }

    es( data, addon ) {
        try {
            return CryptoJS.AES.encrypt( this.getSalt() + '$' + data, this.string + addon ).toString();
        }
        catch( e ) {
            //
        }
        return null;
    }

    ds( data, addon ) {
        try {
            let s = gpCommon.getString( CryptoJS.AES.decrypt( data, this.string + addon ).toString( CryptoJS.enc.Utf8 ), null );
            if( s != null ) {
                let parts = s.split( '$', 2 )

                let p1 = gpCommon.getString( parts[0], null );
                let p2 = gpCommon.getString( parts[1], null );
                if( ( p1 != null ) && ( p2 != null ) ) {
                    return p2;
                }
            }
        }
        catch( e ) {
            //
        }
        return null;
    }

    getSalt() {
        let salt = '';
        let slen = this.getRandom( 20, 30 );
        for( let i = 0; i < slen; i++ ) {
            salt += this.chars[this.getRandom( 0, this.chars.length - 1 )];
        }
        return salt;
    }

    getRandom( min, max ) {
        return Math.floor(Math.random() * ( max - min + 1 ) + min );
    }

}